import React, { useState, useEffect } from 'react';
import style from './index.module.scss';
import { useAppSelector } from '@web-common/state/createStore';
import { apiHolder, apis } from 'api';
const nimApi = apiHolder.api.requireLogicalApi(apis.imApiImpl);
const MailSize = (props) => {
    const currentMailId = useAppSelector(state => { var _a; return (_a = state.mailReducer.currentMail) === null || _a === void 0 ? void 0 : _a.cid; });
    const mailImgSize = useAppSelector(state => { var _a; return ((_a = state.mailReducer.currentMail) === null || _a === void 0 ? void 0 : _a.mailImgSize) || 0; });
    const currentMailContent = useAppSelector(state => { var _a, _b; return (_b = (_a = state.mailReducer.currentMail) === null || _a === void 0 ? void 0 : _a.entry) === null || _b === void 0 ? void 0 : _b.content.content; });
    const attachments = useAppSelector(state => state.attachmentReducer.attachments);
    const [totalSize, setTotalSize] = useState('0');
    useEffect(() => {
        const currentAttachments = attachments.filter(item => { var _a; return item.mailId === currentMailId && !((_a = item.flag) === null || _a === void 0 ? void 0 : _a.usingCloud); });
        const currentAttachmentsSize = currentAttachments.reduce((acc, cur) => acc + (cur.fileSize || cur.size), 0);
        const contentSize = currentMailContent ? currentMailContent.length : 0;
        const total = currentAttachmentsSize + contentSize + mailImgSize;
        if (total < 1024) {
            setTotalSize(`${total}B`);
        }
        else if (total < 1024 * 1024) {
            setTotalSize(`${(total / 1024).toFixed(1)}KB`);
        }
        else {
            setTotalSize(`${(total / 1024 / 1024).toFixed(1)}MB`);
        }
    }, [attachments, currentMailContent, mailImgSize]);
    return React.createElement("div", { className: style.mailSize },
        "\u90AE\u4EF6\u5927\u5C0F: ",
        totalSize);
};
export default MailSize;
